import { LayoutGrid, List, Table2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const ICONS = { table: Table2, grid: LayoutGrid, list: List }

const ViewToggle = ({ value, onChange, views = ['table', 'grid'] }) => {
  const { t } = useTranslation()

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white p-1">
      {views.map((view) => {
        const Icon = ICONS[view]
        const active = value === view
        const viewLabel = t(`cartesAcces.shared.view.${view}`, { defaultValue: view })
        return (
          <button
            key={view}
            type="button"
            aria-label={t('cartesAcces.shared.view.aria', { view: viewLabel })}
            aria-pressed={active}
            onClick={() => onChange(view)}
            className={`grid h-8 w-8 place-items-center rounded-md transition ${
              active ? 'bg-brand-700 text-white' : 'text-gray-500 hover:bg-gray-50'
            }`}
          >
            <Icon className="h-4 w-4" />
          </button>
        )
      })}
    </div>
  )
}

export default ViewToggle
